import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { BillingInvoiceEditService } from '../../../services/billing/billing-invoice/billing-invoice-edit.service';
import { AuthService } from '../../../services/auth.service';
import { BillingInvoiceEntityCreditEditService } from '../../../services/billing/billing-invoice/billing-invoice-entity-credit-edit.service';

@Component({
  selector: 'app-billing-invoice-entity-credit-edit',
  templateUrl: './billing-invoice-entity-credit-edit.component.html',
  styleUrls: ['./billing-invoice-entity-credit-edit.component.css'],
  providers: [{ provide: BillingInvoiceEditService, useClass: BillingInvoiceEntityCreditEditService }]
})
export class BillingInvoiceEntityCreditEditComponent implements OnInit {

  loading: boolean;
  id: number;
  invoiceTypeId: number;

  constructor( private menuService: MenuService,
               private billingInvoiceEditService: BillingInvoiceEditService,
               private authService: AuthService,
               private route: ActivatedRoute ) {
    this.menuService.setMenuTitle('Nota de crédito', 'Entidad');
  }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async params => {
      this.id = +params['Id'];
      this.billingInvoiceEditService.setBillingInvoiceCreditParams(this.authService.getSectorId(),
        this.id);
      this.loading = false;
    });
  }
}
